<div class="myDiv">
  <div style="flex-grow: 1; overflow-y: auto">
    <div class="dialog-content-fixer">
      <app-asign-family #assign></app-asign-family>
    </div>
  </div>

  <div style="height: 30px">
    <button mat-raised-button color="accent" (click)="close()">
      {{ settings.lang.close }}
    </button>
    <button
      mat-raised-button
      (click)="edit()"
      style="margin-left: 8px; margin-right: 8px"
    >
      {{ settings.lang.volunteerInfo }}
    </button>
  </div>
</div>
